// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"298":"717276f9d16cc4f8fe44","833":"9cad2cd2b04ae2c25201","913":"04feb0de4b5aa1fedef5","926":"80f1bae5b34c0ed5ca2a"}[chunkId] + ".chunk.js";
};